<template>
    <div class="main-block">
        <router-link
            class="vw-image-block"
            v-for="(product, index) in products"
            :to="{name: 'wechatProduct', query: { productId: product.productId }}"
            :key="index">
            <img :src="product.image" alt="">
            <strong>{{product.productName}}</strong>
        </router-link>
    </div>
</template>

<script>
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';

export default {
    name: 'wechatProductCate',
    components: {
        Layout,
    },
    data() {
        return {
            pageName: '',
            products: [],
        };
    },
    mounted() {
        const self = this;
        const { pageId } = this.$route.query;
        ajax.get('/web/wx/page_detail.json', {
            id: pageId,
        }).then((result) => {
            self.pageName = result.data.pageName;
            self.products = result.data.pageProducts;
        }).catch(() => {});
    },
};
</script>
<style lang="less" scoped>
    .vw-image-block {
        display: block;
        position: relative;
        margin: 0 auto;
        padding-top: 20px;
        overflow: hidden;
        text-align: center;
        img {
            border-radius: 4px;
            width: 345px;
            height: 175px;
        }
        strong {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 32px;
            font-weight: 600;
            color: #fff;
        }
    }
</style>
